import Link from 'next/link'

import Button from 'components/forms/Button'
import LeftRobotCard from './common/LeftRobotCard'
import useWindowSize from 'components/util/useWindowSize'

const VirtualOfficePromoCard = () => {
  const size = useWindowSize()

  return (
    <LeftRobotCard
      image={{
        alt: 'Robot arm holding mail',
        desktop: {
          dimensions: {
            height: 680,
            width: 550,
          },
          src: '/images/new/robot-arm-mail-desktop.png',
        },
        mobile: {
          dimensions: {
            height: 704,
            width: 550,
          },
          src: '/images/new/robot-arm-mail.png',
        },
      }}
      imageContainerWidth={size.isLgOrHigher ? '35%' : '100%'}
      imageStyle={{
        objectFit: 'cover',
        objectPosition: 'right top',
        width: '100%',
      }}
    >
      <div className='d-flex flex-1 flex-column gap-4 px-4 pt-4 pb-5 pe-lg-8 pt-lg-18 pb-lg-7 mt-lg-0 mt-n12'>
        <h3 className='fw-semibold fs-fluid-36-52 lh-105'>
          Our <span className='color-pink2'>virtual office service </span> gives
          you AI-powered mail management, included with a prestigious business
          address. Never miss your business post.
        </h3>
        <span className='fw-semibold lh-132 fs-fluid-18-22'>
          <div>
            You get it all in one price plan when you subscribe to your new
            virtual office address.
            <br />
            <br />
            <span className='fw-bold'>
              10-minute setup and no postage fees.
            </span>
          </div>
        </span>
        <Link
          className='align-self-lg-end'
          href={'/virtual-office-london-old-street'}
        >
          <Button className='w-100 w-lg-auto'>Find out more</Button>
        </Link>
      </div>
    </LeftRobotCard>
  )
}

export default VirtualOfficePromoCard
